export default {
  'app.name': 'Monexa',
  'app.tagline': 'International transfers',
  'nav.language': 'Language',

  'common.loading': 'Loading…',
  'common.retry': 'Try again',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.required': 'Required field',
  'common.session': 'Secure session',

  'errors.server': 'Something went wrong. Please try again.',
  'errors.session': 'Your session has expired. Please sign in again.',

  'login.eyebrow': 'Client area',
  'login.title': 'Sign in to your account',
  'login.subtitle': 'Enter your personal identification code to view your balance and transactions.',
  'login.codeLabel': 'Identification code',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Sign in',
  'login.submitting': 'Signing in…',
  'login.forgot': 'Forgot your code?',
  'login.error.required': 'Please enter your identification code.',
  'login.error.invalid': 'Incorrect identification code. {{left}} attempt left out of 2.',
  'login.error.locked': 'Two failed attempts. Access is locked for {{minutes}} minutes.',
  'login.error.blocked': 'Access from your network is blocked. Please contact support.',
  'login.error.disabled': 'This account is temporarily disabled. Please contact support.',
  'login.security.title': 'Security and privacy',
  'login.security.text': 'All exchanges are encrypted. Every sign-in is monitored and logged to protect your account.',
  'login.meta.1': 'Encrypted connection (HTTPS)',
  'login.meta.2': 'Two attempts maximum per session',
  'login.meta.3': 'Balances verified server-side',
  'login.recover.title': 'Secure recovery',
  'login.recover.text': 'Enter your identification code. If a matching account exists, a recovery procedure will be sent to the registered address.',
  'login.recover.submit': 'Start recovery',
  'login.recover.done': 'Request recorded. If your account exists, you will receive instructions by e-mail.',
  'login.help.title': 'Need help?',
  'login.help.text': 'Our support team is here for you',
  'login.footer.rights': '© {{year}} Monexa. All rights reserved.',
  'login.footer.privacy': 'Privacy',
  'login.footer.terms': 'Terms',
  'login.footer.security': 'Security',

  'dash.hello': 'Hello, {{name}}',
  'dash.subtitle': 'Here is an overview of your Monexa account.',
  'dash.available': 'Available balance',
  'dash.currency': 'Currency',
  'dash.holder': 'Account holder',
  'dash.account': 'Monexa account',
  'dash.withdraw': 'Request a withdrawal',
  'dash.history': 'Transaction history',
  'dash.recent': 'Recent transactions',
  'dash.empty': 'No transactions recorded yet.',
  'dash.support.title': 'Support',
  'dash.support.text': 'Our team replies Monday to Friday, 9am – 6pm.',
  'dash.support.email': 'Contact support',
  'dash.card.title': 'Demo card',
  'dash.card.demo': 'Virtual demo card — no real payment value.',
  'dash.card.brand': 'Network',
  'dash.pending': 'Request in progress',
  'dash.pending.text': 'A withdrawal request is currently being processed.',
  'dash.logout': 'Sign out',
  'dash.table.date': 'Date',
  'dash.table.label': 'Transaction',
  'dash.table.amount': 'Amount',
  'dash.table.balance': 'Balance',
  'dash.credit': 'Credit',
  'dash.debit': 'Debit',
  'dash.showAll': 'Show all',
  'dash.hideAll': 'Collapse',

  'withdraw.title': 'Withdrawal request',
  'withdraw.subtitle': 'Enter the beneficiary details. The amount matches your available balance exactly.',
  'withdraw.step1': 'Beneficiary',
  'withdraw.step2': 'Bank',
  'withdraw.step3': 'Summary',
  'withdraw.fullName': 'Beneficiary full name',
  'withdraw.fullNamePh': 'e.g. Amara Diallo',
  'withdraw.bank': 'Beneficiary bank',
  'withdraw.bankPh': 'Select a bank',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'FR76 3000 4000 0312 3456 7890 143',
  'withdraw.phone': 'Phone number',
  'withdraw.phonePh': '+33 6 12 34 56 78',
  'withdraw.email': 'Beneficiary e-mail',
  'withdraw.emailPh': 'beneficiary@email.com',
  'withdraw.amount': 'Withdrawal amount',
  'withdraw.amountHint': 'Locked amount — it matches your available balance exactly.',
  'withdraw.currency': 'Currency',
  'withdraw.submit': 'Continue to bank',
  'withdraw.submitting': 'Saving…',
  'withdraw.verify': 'Amount verified server-side before saving',
  'withdraw.error.required': 'Please complete all required fields.',
  'withdraw.error.iban': 'The IBAN format looks incorrect.',
  'withdraw.error.email': 'This e-mail address is not valid.',
  'withdraw.error.noFunds': 'Your available balance does not allow a withdrawal.',
  'withdraw.error.pending': 'A withdrawal request is already being processed.',
  'withdraw.noBanks': 'No bank available at the moment.',

  'bank.title': 'Bank authentication',
  'bank.subtitle': 'Sign in with your bank to complete the request.',
  'bank.bankName': 'Selected bank',
  'bank.login': 'Banking identifier',
  'bank.loginPh': 'Your identifier',
  'bank.password': 'Banking password',
  'bank.passwordPh': 'Your password',
  'bank.continue': 'Verify and continue',
  'bank.submitting': 'Verifying…',
  'bank.attempts': 'Attempt {{used}} of 2',
  'bank.error.required': 'Please enter your banking credentials.',
  'bank.error.invalid': 'Incorrect banking credentials. {{left}} attempt left out of 2.',
  'bank.error.locked': 'Authentication locked after two attempts. Your request is suspended.',
  'bank.demoHint': 'Demo credentials',
  'bank.secure': 'End-to-end secure connection',

  'recap.title': 'Request recorded',
  'recap.subtitle': 'Your withdrawal request has been received. It will be processed after verification.',
  'recap.reference': 'Transaction reference',
  'recap.status': 'Status',
  'recap.beneficiary': 'Beneficiary',
  'recap.bank': 'Bank',
  'recap.iban': 'Bank details',
  'recap.amount': 'Amount',
  'recap.currency': 'Currency',
  'recap.date': 'Request date',
  'recap.note': 'The withdrawal has not been executed yet. The status will update after validation.',
  'recap.dashboard': 'Back to dashboard',
  'recap.print': 'Print summary',

  'dash.viewRequest': 'View request',
  'withdraw.lockedTitle': 'Locked amount',
  'withdraw.pendingTitle': 'Request already in progress',
  'withdraw.pendingText': 'You already have a withdrawal request in progress. Open its summary to follow the status.',
  'withdraw.viewPending': 'View request',
  'bank.demoText': 'Demo environment: identifier firstname.lastname (e.g. amara.diallo), password Bank@2026.',

  'admin.title': 'Back office',
  'admin.subtitle': 'Monexa administration',
  'admin.clientArea': 'Client area',
  'admin.logout': 'Sign out',
  'admin.group.pilotage': 'Overview',
  'admin.group.clients': 'Clients',
  'admin.group.security': 'Security',
  'admin.group.messaging': 'Messaging',
  'admin.group.audit': 'Audit',
  'admin.group.config': 'Configuration',
  'admin.nav.overview': 'Dashboard',
  'admin.nav.transfers': 'Transfers',
  'admin.nav.withdrawals': 'Withdrawal requests',
  'admin.nav.clients': 'Clients',
  'admin.nav.credentials': 'Credentials & access',
  'admin.nav.messaging': 'Messaging',
  'admin.nav.codes': 'Validation codes',
  'admin.nav.ips': 'Security & IP addresses',
  'admin.nav.logs': 'Activity logs',
  'admin.nav.banks': 'Banks',
  'admin.nav.settings': 'Settings',
  'admin.nav.data': 'Management & deletion',

  'admin.common.loading': 'Loading…',
  'admin.common.error': 'Could not load this data.',
  'admin.common.retry': 'Try again',
  'admin.common.cancel': 'Cancel',
  'admin.common.close': 'Close',
  'admin.common.save': 'Save',
  'admin.common.delete': 'Delete',
  'admin.common.actions': 'Actions',
  'admin.common.status': 'Status',
  'admin.common.all': 'All',
  'admin.common.none': 'No data',

  'admin.login.eyebrow': 'Administrator area',
  'admin.login.title': 'Administrator access',
  'admin.login.subtitle': 'Sign in to manage the Monexa platform.',
  'admin.login.email': 'E-mail address',
  'admin.login.password': 'Password',
  'admin.login.submit': 'Sign in',
  'admin.login.submitting': 'Signing in…',
  'admin.login.error': 'Incorrect administrator credentials.',
  'admin.login.locked': 'Too many attempts. Try again in {{minutes}} minutes.',
  'admin.login.blocked': 'Access blocked from this network. Please contact support.',
  'admin.login.demo': 'Admin access: izisender@gmail.com — password can be changed in settings.',
  'admin.login.backClient': 'Client area',
  'admin.login.show': 'Show password',
  'admin.login.hide': 'Hide password',
  'admin.login.panelTitle': 'Run Monexa with confidence.',
  'admin.login.panelText': 'Clients, balances, withdrawal requests and security — all managed from a single, fully logged interface.',
  'admin.login.meta1': 'Protected administrator access',
  'admin.login.meta2': 'Every action is logged',
  'admin.login.meta3': 'IP blocking and validation codes',

  'admin.overview.clients': 'Clients',
  'admin.overview.activeHint': '{{count}} active accounts',
  'admin.overview.withdrawals': 'Withdrawal requests',
  'admin.overview.allTime': 'Since launch',
  'admin.overview.pending': 'Pending',
  'admin.overview.awaiting': 'To review',
  'admin.overview.executed': 'Executed',
  'admin.overview.completed': 'Completed payouts',
  'admin.overview.balances': 'Recorded balances',
  'admin.overview.byCurrency': 'Grouped by currency',
  'admin.overview.accounts': '{{count}} account(s)',
  'admin.overview.statuses': 'Request statuses',
  'admin.overview.statusesHint': 'Withdrawal request distribution',
  'admin.overview.recentRequests': 'Latest requests',
  'admin.overview.seeAll': 'View all',
  'admin.overview.recent': 'Latest transactions',
  'admin.overview.alerts': 'Security alerts',
  'admin.overview.noAlerts': 'No active alerts.',
  'admin.overview.activity': 'Recent activity',
  'admin.overview.transfers': 'Transfers',
  'admin.overview.transfersPending': 'Pending transfers',
  'admin.overview.transfersExecuted': 'Executed transfers',
  'admin.overview.recentTransfers': 'Latest transfers',
  'admin.overview.disabledLinks': '{{count}} disabled transfer link(s)',

  'admin.wd.title': 'Withdrawal requests',
  'admin.wd.subtitle': 'Approve, reject or complete client requests.',
  'admin.wd.ref': 'Reference',
  'admin.wd.client': 'Client',
  'admin.wd.beneficiary': 'Beneficiary',
  'admin.wd.bank': 'Bank',
  'admin.wd.amount': 'Amount',
  'admin.wd.status': 'Status',
  'admin.wd.date': 'Date',
  'admin.wd.empty': 'No request yet.',
  'admin.wd.review': 'Review',
  'admin.wd.detail': 'Request details',
  'admin.wd.approve': 'Approve',
  'admin.wd.reject': 'Reject',
  'admin.wd.execute': 'Mark as executed',
  'admin.wd.note': 'Reason / internal note',
  'admin.wd.notePh': 'Explain your decision',
  'admin.wd.noteRequired': 'Please provide a rejection reason.',
  'admin.wd.updated': 'Status updated.',
  'admin.wd.insufficient': 'Balance too low to execute this withdrawal.',
  'admin.wd.alreadyExecuted': 'This request has already been executed.',
  'admin.wd.iban': 'Bank details',
  'admin.wd.phone': 'Phone',
  'admin.wd.email': 'E-mail',
  'admin.wd.submitted': 'Submitted on',
  'admin.wd.created': 'Created on',

  'admin.clients.title': 'Clients',
  'admin.clients.subtitle': 'Client records are created automatically with each new transfer.',
  'admin.clients.search': 'Search a client',
  'admin.clients.new': 'New client',
  'admin.clients.name': 'Full name',
  'admin.clients.email': 'E-mail',
  'admin.clients.phone': 'Phone',
  'admin.clients.currency': 'Currency',
  'admin.clients.card': 'Demo card',
  'admin.clients.balance': 'Balance',
  'admin.clients.status': 'Status',
  'admin.clients.actions': 'Actions',
  'admin.clients.active': 'Active',
  'admin.clients.disabled': 'Disabled',
  'admin.clients.empty': 'No client yet.',
  'admin.clients.bankLogin': 'Banking identifier',
  'admin.clients.manage': 'Manage',
  'admin.clients.create.title': 'Create a client',
  'admin.clients.create.subtitle': 'A demo card and credentials will be generated automatically.',
  'admin.clients.create.amount': 'Initial amount',
  'admin.clients.create.done': 'Account created',
  'admin.clients.create.credentials': 'Generated credentials',
  'admin.clients.create.accessCode': 'Identification code',
  'admin.clients.create.bankLogin': 'Banking identifier',
  'admin.clients.create.bankPassword': 'Banking password',
  'admin.clients.create.warning': 'Share these details through a secure channel. They will not be shown again.',
  'admin.clients.create.card': 'Demo card brand',
  'admin.clients.create.submit': 'Create account',
  'admin.clients.create.missing': 'Full name is required.',
  'admin.clients.create.invalidEmail': 'This e-mail address is not valid.',
  'admin.clients.detail.title': 'Client record',
  'admin.clients.detail.since': 'client since',
  'admin.clients.detail.card': 'Demo card',
  'admin.clients.detail.adjust': 'Adjust balance',
  'admin.clients.detail.adjustAmount': 'Amount (negative to debit)',
  'admin.clients.detail.adjustLabel': 'Transaction label',
  'admin.clients.detail.adjustSubmit': 'Save',
  'admin.clients.detail.regen': 'Regenerate code',
  'admin.clients.detail.disable': 'Disable',
  'admin.clients.detail.enable': 'Reactivate',
  'admin.clients.detail.transactions': 'Transaction history',
  'admin.clients.detail.withdrawals': 'Withdrawal requests',
  'admin.clients.detail.noTx': 'No transaction.',
  'admin.clients.detail.updated': 'Update saved.',
  'admin.clients.detail.newCode': 'New identification code',
  'admin.clients.detail.invalidAmount': 'Enter an amount different from zero.',
  'admin.clients.detail.balanceError': 'Adjustment failed: balance too low.',
  'admin.clients.detail.transfers': 'Linked transfers',
  'admin.clients.detail.sendCredentials': 'Send credentials',
  'admin.clients.detail.credentialsTitle': 'Generated credentials',
  'admin.clients.detail.noEmail': 'No e-mail address recorded for this client.',
  'admin.clients.detail.deleteTitle': 'Delete client record',
  'admin.clients.detail.deleteText': 'This action is permanent: the record, its credentials and sessions will be deleted. The linked transfer remains available.',
  'admin.clients.detail.deleteConfirm': 'Delete permanently',

  'admin.codes.title': 'Validation codes',
  'admin.codes.subtitle': 'Generate and manage confirmation codes.',
  'admin.codes.empty': 'No code generated.',
  'admin.codes.code': 'Code',
  'admin.codes.operation': 'Operation',
  'admin.codes.attempts': 'Attempts',
  'admin.codes.expires': 'Expires on',
  'admin.codes.revoke': 'Revoke',
  'admin.codes.generate': 'Generate a code',
  'admin.codes.generateHint': 'The code can be used only once.',
  'admin.codes.ref': 'Operation reference',
  'admin.codes.validity': 'Validity (min)',
  'admin.codes.created': 'Code generated',
  'admin.codes.type.withdrawal': 'Withdrawal',
  'admin.codes.type.settings': 'Settings',
  'admin.codes.type.login': 'Sensitive sign-in',
  'admin.codes.state.active': 'Active',
  'admin.codes.state.used': 'Used',
  'admin.codes.state.expired': 'Expired',

  'admin.banks.title': 'Banks',
  'admin.banks.subtitle': 'List offered in the withdrawal form.',
  'admin.banks.add': 'Add a bank',
  'admin.banks.name': 'Bank name',
  'admin.banks.country': 'Country',
  'admin.banks.swift': 'SWIFT code',
  'admin.banks.order': 'Order',
  'admin.banks.active': 'Bank active',
  'admin.banks.save': 'Save',
  'admin.banks.empty': 'No bank registered.',
  'admin.banks.saved': 'Bank saved.',
  'admin.banks.edit': 'Edit bank',
  'admin.banks.nameRequired': 'Bank name is required.',
  'admin.banks.toggle': 'Enable or disable',
  'admin.banks.activeLabel': 'Active',
  'admin.banks.inactiveLabel': 'Inactive',

  'admin.ip.title': 'IP blocking',
  'admin.ip.subtitle': 'Monitor sign-in attempts and block suspicious networks.',
  'admin.ip.address': 'IP address',
  'admin.ip.country': 'Estimated country',
  'admin.ip.attempts': 'Attempts',
  'admin.ip.failures': 'Failures',
  'admin.ip.lastSeen': 'Last activity',
  'admin.ip.block': 'Block',
  'admin.ip.unblock': 'Unblock',
  'admin.ip.blocked': 'Blocked',
  'admin.ip.blockedTitle': 'Blocked addresses',
  'admin.ip.blockedHint': 'Blocks are enforced server-side.',
  'admin.ip.empty': 'No blocked address.',
  'admin.ip.emptyAttempts': 'No attempt recorded.',
  'admin.ip.note': 'Approximate geolocation',
  'admin.ip.until': 'Until',
  'admin.ip.permanent': 'Permanent block',
  'admin.ip.blockTitle': 'Block an IP address',
  'admin.ip.blockWarning': 'Active sessions from this address will be closed immediately.',
  'admin.ip.reason': 'Blocking reason',
  'admin.ip.reasonPh': 'Repeated attempts, suspicious behaviour…',
  'admin.ip.hours': 'Duration (hours)',
  'admin.ip.hoursHint': '0 = permanent block',
  'admin.ip.blockedDone': 'IP address blocked.',
  'admin.ip.unblockedDone': 'Block lifted.',
  'admin.ip.stateActive': 'Active',
  'admin.ip.stateLifted': 'Lifted',
  'admin.ip.manualTitle': 'Block an address manually',
  'admin.ip.manualSubtitle': 'Enter an IP address to block it immediately.',
  'admin.ip.manualDefaultReason': 'Manual administrator block',
  'admin.ip.invalidIp': 'Invalid IP address.',
  'admin.ip.invalidDuration': 'Invalid duration (0 to 8760 hours).',
  'admin.ip.historyTitle': 'Blocking history',
  'admin.ip.historyHint': 'Every block and unblock action.',
  'admin.ip.historyEmpty': 'No blocking event.',
  'admin.ip.historyBlocked': 'Address blocked',
  'admin.ip.historyUnblocked': 'Block lifted',

  'admin.logs.title': 'Activity logs',
  'admin.logs.subtitle': 'History of sensitive platform actions.',
  'admin.logs.date': 'Date',
  'admin.logs.actor': 'Actor',
  'admin.logs.action': 'Action',
  'admin.logs.target': 'Target',
  'admin.logs.ip': 'IP address',
  'admin.logs.empty': 'No event recorded.',
  'admin.logs.search': 'Filter by action',
  'admin.logs.apply': 'Filter',

  'admin.settings.title': 'Settings',
  'admin.settings.subtitle': 'Platform and security settings.',
  'admin.settings.general': 'General',
  'admin.settings.platformName': 'Platform name',
  'admin.settings.supportEmail': 'Support e-mail (shown to clients)',
  'admin.settings.adminEmail': 'Administrator sign-in e-mail',
  'admin.settings.adminEmailHint': 'Verification is required before activation.',
  'admin.settings.maxAttempts': 'Allowed sign-in attempts',
  'admin.settings.generalSaved': 'Settings saved.',
  'admin.settings.security': 'Administrator password',
  'admin.settings.currentPassword': 'Current password',
  'admin.settings.newPassword': 'New password',
  'admin.settings.confirmPassword': 'Confirm password',
  'admin.settings.changePassword': 'Change password',
  'admin.settings.passwordRules': 'At least 10 characters, with upper case, lower case and a number.',
  'admin.settings.passwordWeak': 'The password does not meet requirements.',
  'admin.settings.passwordMismatch': 'Passwords do not match.',
  'admin.settings.passwordWrong': 'Current password is incorrect.',
  'admin.settings.passwordDone': 'Password changed.',
  'admin.settings.invalidEmail': 'This e-mail address is not valid.',
  'admin.settings.notifications': 'Telegram notifications',
  'admin.settings.telegramEnabled': 'Enable Telegram notifications',
  'admin.settings.telegramToken': 'Bot token',
  'admin.settings.telegramChat': 'Channel identifier',
  'admin.settings.telegramHint': 'Alerts are sent as soon as a token and channel are provided.',
  'admin.settings.siteUrl': 'Public site URL',
  'admin.settings.siteUrlHint': 'Used in e-mail buttons (e.g. https://monexa.app).',
  'admin.settings.senderName': 'E-mail sender name',
  'admin.settings.senderNameHint': 'Name shown in the recipient inbox.',
  'admin.settings.role': 'Role of this account',
  'admin.settings.emailSending': 'E-mail sending',
  'admin.settings.emailSender': 'Sending address',
  'admin.settings.emailReady': 'Domain active',
  'admin.settings.emailMissing': 'Domain not configured',

  'admin.data.title': 'Management & deletion',
  'admin.data.subtitle': 'Permanently delete data. This cannot be undone.',
  'admin.data.clients': 'Client accounts',
  'admin.data.withdrawals': 'Withdrawal requests',
  'admin.data.transfers': 'Transfers',
  'admin.data.codes': 'Validation codes',
  'admin.data.ips': 'Blocked IP addresses',
  'admin.data.delete': 'Delete',
  'admin.data.confirmTitle': 'Confirm deletion',
  'admin.data.confirmText': 'This action is permanent. Related data will also be deleted and cannot be restored.',
  'admin.data.deleted': 'Deletion completed.',
  'admin.data.empty': 'No item.',

  'admin.roles.owner': 'Owner',
  'admin.roles.admin': 'Administrator',
  'admin.roles.support': 'Support',

  'admin.emailState.sent': 'Sent',
  'admin.emailState.failed': 'Failed',
  'admin.emailState.queued': 'Queued',
  'admin.emailState.not_configured': 'Not configured',

  'admin.transfers.statTotal': 'Transfers',
  'admin.transfers.statPending': 'Pending',
  'admin.transfers.statExecuted': 'Executed',
  'admin.transfers.statMail': 'E-mails to review',
  'admin.transfers.title': 'Bank transfers',
  'admin.transfers.subtitle': 'Create a transfer to a beneficiary and follow its notification.',
  'admin.transfers.new': 'New transfer',
  'admin.transfers.newHint': 'The beneficiary immediately receives an e-mail with a link to bank authentication.',
  'admin.transfers.empty': 'No transfer recorded.',
  'admin.transfers.ref': 'Reference',
  'admin.transfers.beneficiary': 'Beneficiary',
  'admin.transfers.bank': 'Beneficiary bank',
  'admin.transfers.amount': 'Amount',
  'admin.transfers.status': 'Status',
  'admin.transfers.emailStatus': 'Notification',
  'admin.transfers.date': 'Date',
  'admin.transfers.open': 'Open',
  'admin.transfers.submit': 'Create transfer',
  'admin.transfers.missing': 'Please complete all required fields.',
  'admin.transfers.invalidEmail': 'This e-mail address is not valid.',
  'admin.transfers.invalidIban': 'The IBAN looks incorrect (8 characters minimum).',
  'admin.transfers.invalidAmount': 'The amount must be greater than zero.',
  'admin.transfers.amountTooHigh': 'The amount exceeds the allowed ceiling ({{max}}).',
  'admin.transfers.amountHint': 'Ceiling: {{max}}.',
  'admin.transfers.invalidBank': 'Select an active beneficiary bank.',
  'admin.transfers.createdSent': 'Transfer {{reference}} created and notification sent.',
  'admin.transfers.createdNoMail': 'Transfer {{reference}} created, but the notification could not be sent. Check the e-mail configuration.',
  'admin.transfers.alreadyExecuted': 'This transfer has already been executed.',
  'admin.transfers.resent': 'Notification re-sent.',
  'admin.transfers.resendFailed': 'Could not re-send: the e-mail configuration is incomplete.',
  'admin.transfers.updated': 'Transfer updated.',
  'admin.transfers.detail': 'Transfer details',
  'admin.transfers.resend': 'Re-send e-mail',
  'admin.transfers.cancel': 'Cancel transfer',
  'admin.transfers.execute': 'Mark as executed',
  'admin.transfers.by': 'Created by',
  'admin.transfers.note': 'Internal note',
  'admin.transfers.notePh': 'External reference, instruction…',
  'admin.transfers.firstName': 'Beneficiary first name',
  'admin.transfers.lastName': 'Beneficiary last name',
  'admin.transfers.email': 'Beneficiary e-mail',
  'admin.transfers.iban': 'Beneficiary IBAN',
  'admin.transfers.currency': 'Currency',
  'admin.transfers.lang': 'Beneficiary language',
  'admin.transfers.bankPh': 'Select a bank',
  'admin.transfers.mailInfo': 'An e-mail with the amount and an “Activate my transfer” button is sent to the beneficiary as soon as you confirm.',
  'admin.transfers.emailError': 'Delivery error',
  'admin.transfers.activation': 'Bank authentication',
  'admin.transfers.activationLink': 'Beneficiary activation link',
  'admin.transfers.activationHint': 'This link opens the bank authentication page tied to the selected bank.',
  'admin.transfers.copyLink': 'Copy link',
  'admin.transfers.openLink': 'Open page',
  'admin.transfers.linkCopied': 'Activation link copied.',
  'admin.transfers.verifiedAt': 'Authenticated on',
  'admin.transfers.awaitingAuth': 'Awaiting bank authentication',
  'admin.transfers.notVerified': 'The beneficiary must authenticate with their bank before this transfer can be executed.',
  'admin.transfers.resendHint': 'A new link is generated, attempts are reset and the e-mail is re-sent.',
  'admin.transfers.statVerified': 'Authenticated',
  'admin.transfers.authAttempts': 'Failed attempts',
  'admin.transfers.filterVerified': 'Authenticated',
  'admin.transfers.linkColumn': 'Link',
  'admin.transfers.linkActive': 'Active',
  'admin.transfers.linkDisabled': 'Disabled',
  'admin.transfers.linkDisable': 'Disable link',
  'admin.transfers.linkEnable': 'Re-enable link',
  'admin.transfers.linkDisabledAt': 'Link disabled on {{date}}.',
  'admin.transfers.linkDisabledHint': 'This link is disabled: the page is unreachable.',
  'admin.transfers.linkEnabled': 'Link re-enabled.',
  'admin.transfers.linkDisableDone': 'Link disabled.',
  'admin.transfers.pdfOpen': 'PDF preview',
  'admin.transfers.pdfDownload': 'Download the PDF',
  'admin.transfers.clientRecord': 'Linked client record',
  'admin.transfers.clientLogin': 'Login',
  'admin.transfers.clientLinked': 'Record created',
  'admin.transfers.clientCreated': 'Client record, card and credentials generated automatically (login: {{login}}).',
  'admin.transfers.noClient': 'No client record linked to this transfer.',
  'admin.transfers.sendCredentials': 'Send credentials',
  'admin.transfers.credentialsSent': 'Credentials sent to the beneficiary.',
  'admin.transfers.credentialsNotSent': 'Credentials generated but the e-mail could not be delivered.',
  'admin.transfers.statLinks': 'Disabled links',

  'admin.mail.compose': 'New message',
  'admin.mail.composeHint': 'Write a custom e-mail to a client.',
  'admin.mail.recipient': 'Recipient (client)',
  'admin.mail.recipientPh': 'Select a client',
  'admin.mail.recipientManual': 'Or enter an e-mail address',
  'admin.mail.templates': 'Predefined templates',
  'admin.mail.tpl.welcome': 'Welcome',
  'admin.mail.tpl.transfer_info': 'Incoming transfer',
  'admin.mail.tpl.security': 'Security alert',
  'admin.mail.tpl.withdrawal': 'Withdrawal update',
  'admin.mail.tpl.reminder': 'Activation reminder',
  'admin.mail.subject': 'Subject',
  'admin.mail.subjectPh': 'E-mail subject',
  'admin.mail.message': 'Message',
  'admin.mail.messagePh': 'Write your message…',
  'admin.mail.preview': 'Preview',
  'admin.mail.send': 'Send e-mail',
  'admin.mail.sent': 'E-mail sent.',
  'admin.mail.notSent': 'E-mail not sent: the delivery configuration is incomplete.',
  'admin.mail.missing': 'Recipient, subject and message are required.',
  'admin.mail.invalidEmail': 'This e-mail address is not valid.',
  'admin.mail.deliveryInfo': 'Sending requires an API key and a verified sending domain in the Resend panel. Without them the e-mail is recorded but not delivered.',
  'admin.mail.history': 'E-mail history',
  'admin.mail.historyHint': 'Every message sent and its status.',
  'admin.mail.empty': 'No e-mail sent.',

  'admin.cred.title': 'Credentials & access',
  'admin.cred.subtitle': 'Generate new credentials and send them to the client by e-mail.',
  'admin.cred.client': 'Client',
  'admin.cred.clientPh': 'Select a client',
  'admin.cred.email': 'Delivery address',
  'admin.cred.emailHint': 'Credentials will be sent to this address.',
  'admin.cred.current': 'Selected account',
  'admin.cred.warning': 'Generating new credentials invalidates the current ones and signs the client out of every session.',
  'admin.cred.generate': 'Generate and send credentials',
  'admin.cred.done': 'Credentials generated',
  'admin.cred.mailSent': 'Credentials sent to {{email}}.',
  'admin.cred.mailNotSent': 'Credentials generated, but the e-mail could not be delivered. Share them manually.',
  'admin.cred.history': 'Delivery history',
  'admin.cred.historyHint': 'Every generation is logged.',
  'admin.cred.empty': 'No credentials sent yet.',

  'admin.authState.created': 'Link sent',
  'admin.authState.identity_verified': 'Identity verified',
  'admin.authState.authenticated': 'Authenticated',
  'admin.authState.locked': 'Locked',
  'admin.authState.closed': 'Closed',

  'flow.eyebrow': 'Incoming bank transfer',
  'flow.title': 'A transfer has been sent to you',
  'flow.subtitle': 'Review the operation, then authenticate with your bank to confirm receipt.',
  'flow.amount': 'Amount received',
  'flow.beneficiary': 'Beneficiary',
  'flow.bank': 'Beneficiary bank',
  'flow.reference': 'Reference',
  'flow.date': 'Operation date',
  'flow.bankPanelTitle': 'Issuing institution',
  'flow.secure1': 'End-to-end encrypted connection',
  'flow.secure2': 'Verification with the issuing bank',
  'flow.secure3': 'Every step is logged',
  'flow.footnote': 'Never share your credentials by phone or e-mail.',
  'flow.bankTitle': 'Bank authentication',
  'flow.bankText': 'Sign in to {{bank}} online banking to authorise receipt of this transfer.',
  'flow.login': 'Banking identifier',
  'flow.loginPh': 'Your banking identifier',
  'flow.password': 'Banking password',
  'flow.passwordPh': 'Your password',
  'flow.authSubmit': 'Authorise receipt',
  'flow.authSubmitting': 'Secure sign-in…',
  'flow.attempts': '{{left}} attempt(s) left',
  'flow.secure': 'Credentials are never stored',
  'flow.errorCredentials': 'The bank rejected these credentials. {{left}} attempt(s) left.',
  'flow.errorRequired': 'Please enter your banking credentials.',
  'flow.successTitle': 'Authentication confirmed',
  'flow.successText': 'Your banking identity has been verified. The transfer is validated and will be processed by the sender.',
  'flow.successPending': 'No further action is required from you. You can close this page.',
  'flow.verifiedAt': 'Verified on',
  'flow.lockedTitle': 'Activation link locked',
  'flow.lockedText': 'Too many incorrect attempts. For your security this operation is suspended. Contact the sender to receive a new link.',
  'flow.expiredTitle': 'Link expired',
  'flow.expiredText': 'This activation link is no longer valid. Contact the sender to receive a new one.',
  'flow.cancelledTitle': 'Operation cancelled',
  'flow.cancelledText': 'This operation was cancelled by the sender.',
  'flow.executedTitle': 'Transfer already executed',
  'flow.executedText': 'This transfer has already been executed. No further action is required.',
  'flow.linkDisabledTitle': 'Link disabled',
  'flow.linkDisabledText': 'This link was disabled by the transfer issuer. Contact them for new instructions.',
  'flow.blockedTitle': 'Access blocked',
  'flow.blockedText': 'Access from your network has been blocked for security reasons. Contact the transfer issuer.',
  'flow.notFoundTitle': 'Operation not found',
  'flow.notFoundText': 'This link is incomplete or no longer exists. Check the e-mail you received or contact support.',
  'flow.statusLabel': 'Operation status',

  'status.draft': 'Draft',
  'status.pending': 'Pending',
  'status.verified': 'Ready to execute',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.executed': 'Executed',
  'status.cancelled': 'Cancelled',
  'status.auth_failed': 'Authentication failed',
};